import React from "react";

const isChunkLoadError = (error) => {
  const name = error?.name ?? "";
  const message = String(error?.message ?? error ?? "");
  return (
    name === "ChunkLoadError" ||
    message.includes("Loading chunk") ||
    message.includes("ChunkLoadError")
  );
};

const wait = (ms) => new Promise((resolve) => globalThis.setTimeout(resolve, ms));

/**
 * React.lazy wrapper that retries transient chunk failures and reloads once when
 * the browser is holding a stale bundle after dev HMR/rebuild.
 */
export function lazyWithRetry(importer, { retries = 2, retryDelayMs = 350 } = {}) {
  return React.lazy(() => {
    const load = async (attempt) => {
      try {
        return await importer();
      } catch (error) {
        if (!isChunkLoadError(error)) {
          throw error;
        }

        if (attempt < retries) {
          await wait(retryDelayMs * attempt);
          return load(attempt + 1);
        }

        const reloadKey = "mytara:chunk-reload";
        const root = globalThis.window;
        if (root && !root.sessionStorage?.getItem(reloadKey)) {
          root.sessionStorage?.setItem(reloadKey, "1");
          root.location.reload();
          return new Promise(() => {});
        }

        root?.sessionStorage?.removeItem(reloadKey);
        throw error;
      }
    };

    return load(1);
  });
}

export default lazyWithRetry;
